(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/grassroots-partner/assets/javascripts/components/club-added.js') >= 0) return;  svs.modules.push('/modules/grassroots-partner/assets/javascripts/components/club-added.js');
"use strict";

(function (svs, React) {
  'use strict';

  class ClubAdded extends React.Component {
    componentDidMount() {
      let addedClubArticle = svs.grassroots_partner.data.cms.addedClubArticle;
      addedClubArticle = addedClubArticle.replace('xxx', this.props.userName);
      const addedClub = document.getElementById('addedClub');
      addedClub.innerHTML = addedClubArticle;
    }
    render() {
      return React.createElement("div", {
        className: "f-content"
      }, React.createElement("div", {
        className: "col-xs-12 bg-white"
      }, React.createElement("div", {
        className: "col-md-6 col-md-offset-3 padding-xs-1"
      }, React.createElement("form", null, React.createElement("h2", {
        className: "align-center"
      }, "Tack och v\xE4lkomna!"), React.createElement("div", {
        className: "control-group"
      }, React.createElement("p", {
        id: "addedClub"
      }), React.createElement("a", {
        className: "block align-center padding-bottom",
        href: "https://www.svenskaspel.se/grasroten/marknadsforing",
        rel: "noopener noreferrer",
        target: "_blank"
      }, "Gratis banners och marknadsf\xF6ring"), React.createElement("a", {
        className: "block align-center padding-bottom",
        href: "https://www.svenskaspel.se/grasroten",
        rel: "noopener noreferrer",
        target: "_blank"
      }, "Mer om Gr\xE4sroten"), React.createElement("a", {
        className: "block align-center padding-bottom",
        href: "https://www.svenskaspel.se/",
        rel: "noopener noreferrer",
        target: "_blank"
      }, "Svenska Spel"))))));
    }
  }
  const mapStateToProps = state => ({
    userName: state.grassroot.userName
  });
  svs.grassroots_partner.ClubAdded = ReactRedux.connect(mapStateToProps)(ClubAdded);
})(svs, React);

 })(window);